var _defs, _style, _path, _rect, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _path9, _path10, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildsoftLogoSquareDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 938.4 938.4",
    style: {
      enableBackground: "new 0 0 938.4 938.4"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs127"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n      .st0{display:none;}\n      .st1{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#BE0A26;stroke-width:32;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n      .st2{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-width:32;stroke-linecap:square;stroke-miterlimit:10;}\n      .st3{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#000000;stroke-width:32;stroke-linecap:round;stroke-miterlimit:10;}\n      .st4{fill:none;}\n      .st5{fill:#BE0A26;}\n   ")), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "g6"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 280,
    height: 81,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEACQAJAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAARJAAAIcAAAFiD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAFYBJwMBIgACEQEDEQH/ xADNAAACAwEBAQAAAAAAAAAAAAAABQQGBwMCAQEBAQEBAQAAAAAAAAAAAAAAAAIBAwQQAAEFAAEC BAQGAgMAAAAAAAQBAgMFBgAREhAwEwcgQCExFDQWNhc3IhUyMzURAAIBAwIDBQQGBwYHAAAAAAEC AwARBCESMVETQWFxIgUQgZEyIKGx0SMUMMFCUnJzdFBigpKyFcIzQ1OzwwYSAAEDAgMGBAQHAQAA AAAAAAEAEQIhEjFBAxAwUXEiMiBAYROBkcHRoeHxQlJyggT/2gAMAwEAAhEDEQAAANAFqssxVZw8 KS1LCV34WMrXssRR2g7+172WYXc56NRP8U5FPHDw416+TibVGbHRV/haVC6MWaXT55YSnyC0FIYF nKy6JgBwgNgQdfUo5dekEjMOMs8RlAOOHduVlst4jjsjl5c7pWWgxipH+bLrfjtXNl2RWFvjhG7x 1+/Wca+SifEZz05c5K9nX1J6bKxmqcN9gbAAUOY3rQ3RTkwwvud6MZXoeeWQrWnZ7oxl18pGnmUa pmenmWajmWnmWW6q2EhM/rMqlkr96y4EPok5etyreo8qy1y11euVlqtorJakrtHXPq1gMdkArkcv VenqTmfsoiLWMsrl30zNL+Z1oOXWEWXqn6SZtc2wZneWfwzHT6tZzMtGzjUDNfWjqCuWKu22eql7 W/vP1WNVIaX5q54splw6rd6pPRumsMDcg2WNNrkAXwWdZKDn6bJ4SRS0RV0dlh9fPvTzgAAAAHz6 CSWwCtWUAQvgUNwPJ6AAAAIU0ykTjqZQBXMADyBz6hmxpIN+gbIAAAAAAAAAAAAAAAAAAAAAAAAH /9oACAECAAEFAPjV317053/I9qde1OK1OnFVE56jOKqJxHtXivai9U6I5q+a5O5HuZ0ci9sqIjZP vJ/wYn+PHO6ca3p5T0VWtexrene301XkqL1eiqjGqicd/i9ZE4siL5qoiojWt+BOJ8j/AP/aAAgB AwABBQD42x9Weg7no/VU6L5/qKjfUfxsrkcv1VGq5VGmREarlfBKxGQyPRWORz4pGebE9Y3wxkK+ NzfUEc50o30aL/3zqqy8ii7uSy96+TA5rZZYZpJO/wBGX8SiII9O2FyI8iRrn8jT1IWjL0aOqL5j XOar5pJPFPu77u+3yH//2gAIAQEAAQUA8w8qUSAIyE4byLKzdXIx7Xs8XXk0hNZYwWYvkX6xtqqb 8c4ykieTl6Zz4c1PFPHmHwuPvbqN8A9y2RtkEM9L/NxEPqSY7EWBoiO1FKYoOcyTiBXXfc0OKNxB qmTMAUogWvGmhif0llqxG9o4YbrExbuc3J5eeRQb0yV2hJnHmoD2P9IuKSW5t0EjzpEKxaeQokNl WSGOSFYxyjmJ62ivJIUs6lhrK7hoQ540efGi5R5t4VQzK10bZaEGUI2pGMmsMukrUpBVLiqBoSYM vXDuizQEb41f+qaWnYfQuphXHXSPeJIDFK5aoXooEDpoq6CKWzBjYLB1bBV1KHkuztcrxqkYU06q FOf+nwPwEGdAgnLoBCprKmGGri6IMwwSmCFgFoQhiZs5XSyGUAJhTcwBGgo0Qg/jZaMSutLi1hpw K06OxBo9IJdymaIUO3tLGKrC/kmlTie5NIq1WoprZ3Lva1VPPW7+lMefvKgA0jUgwVP8k0vWfUhw VP8AJNL1qLge2CsPcOnFlA3lKW2D3EpppCrAYSF+pFRRtGBO5FRyG2AoLP1SL3BWIhzTj4wY/wBU A8BOjOjKJiEgj1AjnxyMlj8dlLHDrtnd1JdBmr6mHosLaVwRdocGbtnNa9uiGGZsnZ6gc3X1cOeu gplIEywkFzrLHK0VhBkwom7BYoljCHHX3AcxjmBjjrvd0e6uz/t9QBSA6/OVM9R7ZjwSR6aCaeAC rDhEvKkJBMyVJMHMjrS8YAEyM2NKa4RWyxhRRLo0RETVOVAqQQWSra1rW+N1nKa2m1WPpKyloMTQ nU+PzdXbEk0wNPs+a2dg+wl9yadrGg2e2tI42xR+3/7o5mP37wH+xeBf2F7kjvlo/b6dkue037e9 sPy6qiIbpBB3FWFjbOpa5QBa1PQv+alyOMFarRgf3NzV/k6H/wAvxJIiGhhjJvytJUz21QPldsND mKzQmEIFcBbDmna1+1noaUiN/fltfobixrGYMGwg0V/anVg+SEs/1de2RlaJRj2s2y4F/YR4UNgH CLp8WVa7W4sK/wBsPy+mIkiCpaEcgdGDBwiGQGRXFPPJOmhso2gVhp5tkQaPGOSUy1rT7El12XYz RV9nawCDvfJDySRkTOhF+XFFHDH4UV6RnzGW093rLU//AFoNtZFl3jvcWze2kzt1c3PwKqNQLdCF Xb3sYle9knuBz781EkEVB7Yfl7cBTxBLM+oQ28KPhz8Ew4HOiL4orQtJYHsDFOhIuqupHlGA8NCr 0q6Zsba3jZI3O4ceOCxrkc3yF+vIMjSj2lzSiXQ1dhqqtP8AC4x9XclUOcEoWcc1rkaxjfisKoWw RmWHRR4IxofEiCMiGAg+kfPoZZ2oDb1ys0w/ZHEZdloiInz7+zth/C9eP/1ve3t6fP8A/9oACAEC AgY/APGzL4OsPIklYJtjlYpymBTEsnyVC+9I4q0Bz6KAlxqnGINFD+wRQ5bGFScFWpOJ3RAVB1cs 0LkLpGTZKJf93yRjcSWfmg5OGGy44ENyVAZDMpo1J3rFUDeHLyP/2gAIAQMCBj8A8d7sKvTg33WI 7rfz/FVLBxEFsz+iI8gAKMSX5ruKEiSWTpgHJyCcwkmAJPAJ5RIHFPGJkFa3U7MhfExfeiYD2oak iYRdyZHLkv8Aonp5QNv1KMSSYzibnWuAcNOShzUwSe87DKRthDuP0HqgALYRpGPDdQMsBJOZPpk0 N1LVL2y4BatXCPt6cdMyDGTv8lqRtBPtyPrL0Q1DpxhAytd+0sjbGI6j1DPYdOJ64zvb+QZdco6c j2xOf2T6wshHGuPoN7dEsRmE05GTeDP4od3+vI//2gAIAQEBBj8A/SGaKBsjbq6IQGCgXJF+NR5U BJjkFxfQg9oPh+hWWTHeTG/6syEfh621U62pXQ3VgCp5g/QyIMLCfJGI/TmfcqDfa9lB40MqAFV3 MjK2jKymzA2/QzNLkHFjUqXmW+4DcNBbnwqXIxknh9JMJ2jJa7PJ2OinUCpvUJp5WyJ0yGdt5tui kkCFR2aKKiyt7vNJAJWdzuO4rftrF9RTKnGRkPB1zvNnEsqhtOypfTpJZEw8HHiKxoxUyM9/MzDU 2tXp2FHkSNFkZkcUjbvOY2Oq7q9F9KWaQYs5nM1mO9+kqFLtx/arPw5MiWWGGBDEGY+XqXrLkjmd sp3nijeRiwUoWWP4VgwztlQzSzImW5e8chJ1KsDpUuIZpeh+T6uzebby/Tv8Ky/U5pHlkR51Bdi3 ySNHGo+qpvT8trySBcyPltm1YDwNCRGZGV0AKm2jMAalgeRxFAihFBsbkA7iffU8QYtOJTjwseJL EBfhesqIsWnxm2hzx2MRtb4GogTOssg06gYK5tftqfPMrrOTIRY6KFYqFt4Coxcm6gkk3Oor1dpM iWOWGbZjurkCPyAggcONYrSa5vqNsZTzYkhnt4CnwJzfI9Oc48hPaALq3vFY3pz/AJg4YxjO8eMr M8jlymuzWy7frr1I4kuSkmCGNpSySRuFuF82tq/+eUTSr15UjlIcgurxmQ7veK9Tmx4pJcfHVBOE l6NmVLvb942rCyPSmfHhkmj27GKkiWQK+7mawY0lkEbwOzR7ztJj2otx4V/9DkxSyNJjOEgBJYIG W9wO41hI7ZyZGRcbp1cRzNsLN8wt3ipvU/UTnB+o/wCLEr9GJVcqACBt8a9HCTS9DLhkkdQxUN00 DoSPtp4gcnJzHiBhxcYkdO1/Ox4a1Aueb5QX8U3vr3n2Pi5S74ZLbhcg6G4II76ldZ8h55IjAJXl JZUuCFUi1tRX5HKyJS8gkWRUlPTCtIzeQEaXU60qRy5KRohjSMTttUN822/C/dWPgMZBjYxUxork XKHcu7nrSZJeSDJRdgngcxvsvfaewjxFYMeJPNGmNkLLJeVrlb3Zl/v8jWLmSSTSzYassJkkLDz6 MSD2msnKR5evlKEkcuWIA4bb8LVGY3nCxyGYxmZijyHcNzKdL+Y8LVCTJPJFjHdBjySlokPZZe7v NZOV0pBBHhbC5U2ZlkDWXnpSY+cs0I/MzTBATG2srOhYfXrUGfvlE+OojQhztKjsZeBvQjRWdmdL BRf5WBN6Et3il2hS8bFSRyNRAb16Lb1IY33n9o34mpJm3MZRtkUm6kdmndSy3d2QWjDsWCA8r1O0 HVVpbkxRk7Wc9pWkuNQouO3hXqs8rZWLHkTWAV2h6ke0A3Xh7+NYjIHiGBpjIjkKvfY3176mzomk 6uRbqqXJRrcPKeV6jmcvFkQgiLIhYxyKG+YXHEG3A1J6eGlEMxJnbeS8pb5t7m5N6x5g80i4lzjQ ySs8cbEbdyq3bbhy7KlmEs+O2QAuQIJCiyADb5hY9nKsbFSHJzIYZ0KRLLYr5h5m5heNqGbNJMJ0 G2IpIyCPhfZttyqeCzTjKJOS8zb2kJFvMfCoskPNM2MrJjLNK0iwhxtbYG7tNb6UzEypFI/Ulxkk ZYXe97lPHlao8uVplmgUrAY5DH0r9qbLWpOjNkRSKhjeVJSHkUkm0htY6nlUeNDcRxDatzc27yfo YvpcsUjy5gBR1ttF2K63N+ynzp0Z44yAVS27XxtUOdErJHOu5Va24C9tbVkxY8UkZxWCuZLWNyRp YnlWN6TJHI02UQEdbbBfnrepM2ZWeOO11QXbU2rWGf8Ayj76AMU4HPaPvrp4k463/acFW9wPH2Ni MHyMlPnSMCyk9jEkClin34kjGw6o8p/xC4HvqTDdJZGjKgvGAVO5Q2mvfUXq3SlfHmbaqhfMNbag 1boz35bR99Q+rNDMYZm2hAvnHHUj3Vboz35bR99HOiR4ogzKeqNp8oBJ8NaMOOkmUymxZANunIsR emEhfGmRWfpyC27aNxCkaXoIIpwWIA8oPHwNLNOxVX+UWJJuL1aOJ279PvoI+6FjoN40+IoEG4PA 1unexPyqNWPurSGTZz0++rwPcj5kOjD3UJJFZlJt5Revkk+A++jJGrKAbeYWpp5jZEGvM9wqzxui fvWB+NjSyIbowup7voejyysEjRFLMeAAkap4MbLjllYrZFa5NjWFDPmRRypHZkZrEG5r1RsrISFZ ZAYyxtuG5uFelSYkyzIGUFkNwDcUVcBlPEEXBpIEhRYWePdGFAQ3Ot1AtrRU+m4tjyhjB+IW9QT+ mXhRwJkQE+RgbEA8baVBOeMkasfEi5qds9BMt5shkbzKzbx8wPEeajE+JHE1rJLCojdT4oBf30MO dVyEhaeP8RQwbpqyg2N+VdIopjtbZYbbcrUIDEhh/MP+EVGzRGPy8ONbGUMhFipFxbwowGJDCMhg I9o2cP3eFMkHkOS64426bVZWY2/y2p/U8qFZpXcpF1FDBQvEgNz51lZiwJDlY0ZlSWJQhOwX2tbi DWZJJEjyI67XZQWXTsJqEQo0hDkkKL9lRB8dDKUUyMygtuI1499PkRIsMkevkFg3dYaU8Uh3dFgF J/dI0H1UYnJ6e/aLdiLXSWCPZwsVB+N6SXH8sT2bb2bSbMtAkAq4BsddDXTKKY98nkIG3RWPCrAW A4AVEAdGksfgTUfUhR99y25Qb699BVFlAsAOX0I8j1EHqIvTQh9uly1vrqbMxI3WZCoUlyRqeVYm XkRuZpk3OQ5AvcjhXqEeYjMuM4WLaxWwuw1+FelwYKssbOrEMd2tx7Ou/wAkRjZrcgb0THFJI3Yv D6yKT1CaMY/p8dkGoJ2A3sO03pI00VAFUdwFqn/lS/609kv83K/9nsH9RJ/429jf1DfZUUiAno5C s3cpRxf42pEU+aORlYfZXqP9PJ/prO/jX7KudBRSAddxxI+W/jQiVCVvpGg+2ir/APNkO5+7ThRR 9DuddefshjXVgmo8TUSniEX7K/xy/wChvZD/ADP+E1D7/t+g00x2ogua/MTXiwoT5FHEn7+ZqTAx nRJHK2aS+3y/wgmkgg9VgSKMWRAWsB74qzl9LzUxpIntkM5Pna7aiyNXpcfq2SuVMZFKul7AXGmq r7EVwGVniBUi4IvRikwYNjcdqBD/AJksa/LYUjHGMkYMZN7pKAdp523caiGBgNnPLe5BICW5gKb3 8almysaWFTDJdnRlXcWXQEi1Rvg4LZ0kjFSqkjZYXubKb0MzKxJYBIZ5HLIwRTIrNbcRbtoTYeG2 bKzbempIt/eNlaoM/LwpYBJK7udjbFujftEW9jf1DfZU2HOLxTKVa3EciPA1IceAZuFKf2QWVgOB IXzKayMRfS+jHJGyzSHe21CPMflUDTnWd/Gv2UsaG3VbaxHIC9Jl5RL77lIwbCwNvNbWmZVWKNBd to7BXWx2LJfbcgjUePjQzsI/jLYsnAkjtWunLh3lGl7MPqtX5/PGxLh7HQsRwAXsApGwoRMSbMD2 D4ivzKRbsncx6VjxKkHv4VKMnHEWxbpoRublqaWPLxxCivdWF9TYjmaSLHxRJEt9r2Y3+BpHkXa7 AFl5H2NI5sqi5NX1TAiPxt+s0scahUUWAHtzycJ5/wAxIbWuLbWb769MyziPjrHIqm9z2jWpMzpN OY7WjT5jc2oeqtiPGVZWERBPyHnRWL020jaKTu4/Cl9Y9VQxxbxIxfQvbgFHL6JY8Bqa/wBq6DKr SGGOa/FhcajvIrc7BRzJtW9CGVshiCOB09mteoKzKjNA4A0BJI0rO/jX7KMSkCRTuQnmKOJPCWRS SoP7N+Ro40UBQPoSLknuopMhRi5IB5ELr7OHt3zeVNxN/wCYhA+s02QtnIsAt+N6x5YVCuWLlSdL DctRwyizre49/tk29pUN4XqDp8Ctzbn2+worAsvzKCCR4j2K897OdqhRc0GHBhce/wDQ2Nf7rHG3 5jcZApbyBzfzBbd9DFy2kWNWD/httNxprcGos7Gkl3xG6q5BHv0HtOXlPMJdoUBHAUW4aFTUqYru 4mILb7dnh7LMARyOteVQvgLfSHVBEi6K68bcq/End0HBQLfrNJBELRoLKDr3/QeGQXRxY0YJojLi 3JRl1+BrpYEDmVtNxF7Uuch6kjazJx486/FidZe1bdtJPOhixIjdVOl6sOA/sA9S23t3cPro9DZf t2W/V7PP0ep/e2bvrobbW7LcP7A//9k=",
    transform: "matrix(8.4353 0 0 -8.49 211.7144 778.7945)",
    id: "image4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M597.6,152.8c-8.6-42.4-46-74.2-90.9-74.2c-51.2,0-86.6,43.9-91.6,53.9l-3.4-4.4c0,0-10.4-10.4-19.7-19.7  c-36.2-36.2-95-36.2-131.2,0C229.1,140,225.2,189,249,225.1l121.6,130",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    style: {
      fill: "#000000",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M557.7,532.7",
    id: "path10",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M459,532.7",
    id: "path12",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M360.4,532.7",
    id: "path18",
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 615.5,
    className: "st4",
    width: 942.1,
    height: 193.9,
    id: "rect30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.3,645.5l-17-4v-11l37-1h23c25,0,43,11,43,35c0,18-9.2,28.2-26,32.4c21,4.8,31,16.6,31,32.6c0,28-18,40-51,40h-57v-12   l17-4V645.5z M102.3,689.5c18,0,30-7,30-23c0-14-10-21-23-21h-22v44H102.3z M108.3,753.5c19,0,29-8,29-23c0-20-13-26-35-26h-15v49   H108.3z",
    id: "path32",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3,768.5l-33,1l-2-14c-4.8,4.2-20.6,16-37,16c-22,0-32-13.8-32-35.8v-56.2l-17-4v-11l37-1v70.2c0,14,5,20.8,18,20.8   c17,0,29-15.8,29-15.8v-59.2l-17-4v-11l37-1v90l17,4V768.5z",
    id: "path34",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.3,769.5h-52v-11l17-5v-74l-17-4v-11l37-1v90l15,5V769.5z M322.3,616.5c8,0,13,4,13,14c0,9-7,14-13,14c-8,0-13-5-13-14   C309.3,621.5,315.3,616.5,322.3,616.5z",
    id: "path36",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.7,769.5h-55.4v-11l17-5v-122l-17-4v-11l37.4-1v138l18,5V769.5z",
    id: "path38",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.7,768.5l-34,1l-1.6-11.4c-5.8,5.8-16.2,13.4-31.4,13.4c-29,0-42-21-42-52c0-34,17-58,53-58c7.4,0,13.8,1.4,19,3.2   v-33.2l-17-4v-11l37-1v138l17,4V768.5z M487.7,681.5c0,0-7-4-21-4c-23.2,0-30,18-30,40s7,38,25,38c17,0,26-15,26-15V681.5z",
    id: "path40",
    style: {
      fill: "#ffffff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M558.7,749.5c0,0,9,5,22,5c14.6,0,30.6-7.2,30.6-21.4c0-30.8-72.2-18-72.2-65.8c0-28,22.4-39.8,47.4-39.8   c19,0,42.2,8,42.2,8l-1,34h-13l-6.8-21.4c0,0-10.2-3.6-21.2-3.6c-18,0-26.6,9.4-26.6,19.4c0,30.4,72,18.8,72,63.8   c0,30-24.2,43.8-52.2,43.8c-21,0-41.2-8-41.2-8v-35h16L558.7,749.5z",
    id: "path42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M745.1,714.5c0,34-20,57-50,57c-30,0-48-18-48-54c0-34,21-56,51-56C728.1,661.5,745.1,682.5,745.1,714.5z    M668.1,716.5c0,24,8,39,28,39s28-14,28-40c0-22-7-38-27-38S668.1,690.5,668.1,716.5z",
    id: "path44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M775.1,652.5c0-24,13-39,37-39c19,0,30,7,30,7v25h-14l-3-16c0,0-5-1-12-1c-14,0-18,8-18,20v16h26.4l-0.6,15   h-25.8v74l20,5v11h-57v-11l17-5v-74h-18v-13l18-2V652.5z",
    id: "path46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M899.1,679.5h-29v64.2c0,9.2,4.4,12.2,10,12.2c4.8,0,10.4-2.2,15.6-5l5.4,10.6c-9,6.6-18,10-28,10   c-12,0-23-6.6-23-29v-63h-20v-13l20-2v-25.2l20-4v29.2h29V679.5z",
    id: "path48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g110"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.3,
    y: 816.3,
    className: "st4",
    width: 855.6,
    height: 89.9,
    id: "rect52"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.3,854.6c0,0,1.6,0.5,4.6,0.5c3.3,0,6.2-0.9,6.2-4.3c0-5.9-15.3-3.2-15.3-13.2c0-5.7,4.4-8.6,10.1-8.6   c4.3,0,9.4,1.7,9.4,1.7l-0.2,7.4h-3.6l-0.9-4.3c0,0-1.7-0.7-4.5-0.7c-2.8,0-4.9,0.9-4.9,3.7c0,5.9,15.3,3.6,15.3,13   c0,6.3-5.5,9.4-12.1,9.4c-5.1,0-8.7-1.2-8.7-1.2v-8.1h3.8L50.3,854.6z",
    id: "path54",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2,833.9h-8v17.7c0,2.5,1.2,3.4,2.7,3.4c1.3,0,2.9-0.6,4.3-1.4l1.5,2.9c-2.5,1.8-4.9,2.8-7.7,2.8c-3.3,0-6.3-1.8-6.3-8   v-17.3h-5.5v-3.6l5.5-0.5v-6.9l5.5-1.1v8h8V833.9z",
    id: "path56",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,833.5c1.4-1.5,4.6-4.6,8.3-4.6c2.8,0,4.9,0.8,4.9,0.8l-0.3,8H112l-0.8-4.1c-4.1,0-6.8,2.7-8,4.3v16.3l5.5,1.4v3H93   v-3l4.7-1.4v-20.3l-4.7-1.1v-3l9.1-0.3L102.6,833.5z",
    id: "path58",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,858.4l-9.1,0.3l-0.5-3.8c-1.3,1.2-5.7,4.4-10.2,4.4c-6,0-8.8-3.8-8.8-9.8v-15.5l-4.7-1.1v-3l10.2-0.3v19.3   c0,3.8,1.4,5.7,4.9,5.7c4.7,0,8-4.3,8-4.3v-16.3l-4.7-1.1v-3l10.2-0.3v24.7l4.7,1.1V858.4z",
    id: "path60",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.3,833.9c0,0-2.2-0.5-4.9-0.5c-5.2,0-8.2,3.3-8.2,10.2c0,7.4,3.3,11.3,8.5,11.3c5.2,0,8.5-3.3,8.5-3.3l1.9,3.3   c0,0-4.9,4.4-11,4.4c-9.1,0-13.7-5.8-13.7-15.1c0-8.8,5.5-15.1,14.3-15.1c4.9,0,9.3,2.2,9.3,2.2l-0.3,7.4h-3.6L173.3,833.9z",
    id: "path62",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,833.9h-8v17.7c0,2.5,1.2,3.4,2.7,3.4c1.3,0,2.9-0.6,4.3-1.4l1.5,2.9c-2.5,1.8-4.9,2.8-7.7,2.8c-3.3,0-6.3-1.8-6.3-8   v-17.3h-5.5v-3.6l5.5-0.5v-6.9l5.5-1.1v8h8V833.9z",
    id: "path64",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.3,858.4l-9.1,0.3l-0.5-3.8c-1.3,1.2-5.7,4.4-10.2,4.4c-6,0-8.8-3.8-8.8-9.8v-15.5l-4.7-1.1v-3l10.2-0.3v19.3   c0,3.8,1.4,5.7,4.9,5.7c4.7,0,8-4.3,8-4.3v-16.3l-4.7-1.1v-3l10.2-0.3v24.7l4.7,1.1V858.4z",
    id: "path66",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.4,833.5c1.4-1.5,4.6-4.6,8.3-4.6c2.8,0,4.9,0.8,4.9,0.8l-0.3,8h-3.6l-0.8-4.1c-4.1,0-6.8,2.7-8,4.3v16.3l5.5,1.4v3   h-15.7v-3l4.7-1.4v-20.3l-4.7-1.1v-3l9.1-0.3L249.4,833.5z",
    id: "path68",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.8,831.2c0,0,6-2.2,10.7-2.2c6.4,0,10.2,2.2,10.2,8.5v16.8l4.4,1.1v3l-8.5,0.3l-1.2-3.8c-1.9,1.9-5.2,4.4-9,4.4   c-5.2,0-8.2-3-8.2-8.2c0-6.3,4.9-8.5,12.6-8.5h4.4V838c0-3.3-1.9-4.9-5.2-4.9s-5.6,0.8-5.6,0.8l-0.8,4.1h-3.6L266.8,831.2z    M278.4,846c-5.5,0-7.6,1.4-7.6,4.7c0,2.5,1.5,4.1,4,4.1c4.1,0,7.4-4.4,7.4-4.4V846H278.4z",
    id: "path70",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.4,858.7h-15.2v-3l4.7-1.4v-33.5l-4.7-1.1v-3l10.3-0.3v37.9l4.9,1.4V858.7z",
    id: "path72",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3,858.7H312v-3l4.7-1.4v-33.5l-4.7-1.1v-3l10.3-0.3v37.9l4.9,1.4V858.7z",
    id: "path74",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8,852.6l6-19l-3.8-0.8v-3l13-0.3v3.3l-3.6,0.5l-7.8,21.8c-2.9,7.6-5.8,16.7-14.8,16.7c-1.4,0-3.5-0.3-3.5-0.3l0.5-3.8   h2.8c3.8,0,6.3-3.6,8.7-9l-9.8-25.1l-3.3-0.8v-3l12.9-0.3v3.3l-3.8,0.5L343.8,852.6z",
    id: "path76",
    style: {
      fill: "#ffffff"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M399.2,858.7h-15.2v-3l4.7-1.4v-33.5l-4.7-1.1v-3l10.3-0.3v37.9l4.9,1.4V858.7z",
    id: "path78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M428.6,843.5c0,9.3-5.5,15.7-13.7,15.7c-8.2,0-13.2-4.9-13.2-14.8c0-9.3,5.8-15.4,14-15.4   S428.6,834.7,428.6,843.5z M407.4,844.1c0,6.6,2.2,10.7,7.7,10.7s7.7-3.8,7.7-11c0-6-1.9-10.4-7.4-10.4   C409.9,833.4,407.4,836.9,407.4,844.1z",
    id: "path80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M445.3,853.7l6.6-20.1l-3.8-0.8v-3l12.3-0.3v3.3l-3,0.5l-9.3,25.3h-6l-9-25l-2.7-0.8v-3l12.4-0.3v3.3l-3.8,0.5   L445.3,853.7z",
    id: "path82"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M467.3,844.9c0,6,3.2,9.9,8,9.9c5.5,0,9.2-3,9.2-3l1.9,2.9c0,0-5.1,4.6-11.7,4.6c-8.8,0-13.2-5.8-13.2-14.8   c0-8.8,5.5-15.4,13.5-15.4s11.5,4.7,11.5,12.9c0,1.4-0.3,2.9-0.3,3H467.3z M480.7,840.8c0-4.1-1.6-7.5-6-7.5   c-4.4,0-6.9,3.4-7.2,7.5H480.7z",
    id: "path84"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M522,858.4l-9.3,0.3l-0.4-3.1c-1.6,1.6-4.5,3.7-8.6,3.7c-8,0-11.5-5.8-11.5-14.3c0-9.3,4.7-15.9,14.6-15.9   c2,0,3.8,0.4,5.2,0.9v-9.1l-4.7-1.1v-3l10.2-0.3v37.9l4.7,1.1V858.4z M511.9,834.5c0,0-1.9-1.1-5.8-1.1c-6.4,0-8.2,5-8.2,11   s1.9,10.4,6.9,10.4c4.7,0,7.1-4.1,7.1-4.1V834.5z",
    id: "path86"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M556.9,832.2c1.8-1.4,4.7-3.2,8.2-3.2c8,0,11.5,5.8,11.5,14.3c0,9.3-5.2,15.9-15.1,15.9c-6,0-10.2-1.4-10.2-1.4v-37.1   l-4.4-1.1v-3l9.9-0.3V832.2z M556.9,854.3c0,0,1.4,0.5,5.5,0.5c6.4,0,8.5-4.9,8.5-11c0-6-1.9-10.4-6.9-10.4c-4.9,0-7.1,3.6-7.1,3.6   V854.3z",
    id: "path88",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.4,852.6l6-19l-3.8-0.8v-3l13-0.3v3.3l-3.6,0.5l-7.8,21.8c-2.9,7.6-5.8,16.7-14.8,16.7c-1.4,0-3.5-0.3-3.5-0.3l0.5-3.8   h2.8c3.8,0,6.3-3.6,8.7-9l-9.8-25.1l-3.3-0.8v-3l12.9-0.3v3.3l-3.8,0.5L595.4,852.6z",
    id: "path90",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.1,844.9c0,6,3.2,9.9,8,9.9c5.5,0,9.2-3,9.2-3l1.9,2.9c0,0-5.1,4.6-11.7,4.6c-8.8,0-13.2-5.8-13.2-14.8   c0-8.8,5.5-15.4,13.5-15.4c8,0,11.5,4.7,11.5,12.9c0,1.4-0.3,2.9-0.3,3H642.1z M655.5,840.8c0-4.1-1.6-7.5-6-7.5   c-4.4,0-6.9,3.4-7.2,7.5H655.5z",
    id: "path92",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.6,833.4c1.3-1.2,5.7-4.5,10.2-4.5c6,0,8.8,3.8,8.8,9.9v15.4l4.1,1.4v3h-13.2v-3l3.6-1.4v-14.8c0-3.8-1.4-5.8-4.9-5.8   c-4.7,0-8,4.4-8,4.4v16.2l3.6,1.4v3h-13.7v-3l4.7-1.4v-20.3l-4.7-1.1v-3l9.1-0.3L675.6,833.4z",
    id: "path94",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.9,833.6c0,0,1.5,2,1.5,5.6c0,7.4-4.9,10.7-12.1,10.7c-2.5,0-4.1-0.5-4.1-0.5l-0.3,5.2h8.5c7.1,0,11,2.7,11,8   c0,6-4.7,9.9-14.3,9.9c-7.7,0-13.2-1.9-13.2-8c0-4.9,5.8-6.9,5.8-6.9s-3.3-0.3-3.3-3.1c0-1.8,2.9-6.2,2.9-6.2s-4.2-1.9-4.2-8.5   c0-7.1,4.9-10.7,12.1-10.7c3.6,0,5.5,1,5.5,1l9.6-0.2v3L725.9,833.6z M712,858.7c0,0-3.6,1.6-3.6,4.9c0,3.8,3.3,4.7,8.5,4.7   c5.5,0,8.3-1.7,8.3-5.2s-2.8-4.4-7.2-4.4H712z M709.5,839.4c0,3.8,1.9,6.6,6,6.6c4.4,0,6.3-1.9,6.3-6.6c0-4.1-1.9-6.6-6-6.6   C711.4,832.8,709.5,835,709.5,839.4z",
    id: "path96",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.1,858.7h-14.3v-3l4.7-1.4v-20.3l-4.7-1.1v-3l10.2-0.3v24.7l4.1,1.4V858.7z M741.9,816.6c2.2,0,3.6,1.1,3.6,3.8   c0,2.5-1.9,3.8-3.6,3.8c-2.2,0-3.6-1.4-3.6-3.8S740,816.6,741.9,816.6z",
    id: "path98",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.8,833.4c1.3-1.2,5.7-4.5,10.2-4.5c6,0,8.8,3.8,8.8,9.9v15.4l4.1,1.4v3h-13.2v-3l3.6-1.4v-14.8c0-3.8-1.4-5.8-4.9-5.8   c-4.7,0-8,4.4-8,4.4v16.2l3.6,1.4v3h-13.7v-3l4.7-1.4v-20.3l-4.7-1.1v-3l9.1-0.3L762.8,833.4z",
    id: "path100",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.6,844.9c0,6,3.2,9.9,8,9.9c5.5,0,9.2-3,9.2-3l1.9,2.9c0,0-5.1,4.6-11.7,4.6c-8.8,0-13.2-5.8-13.2-14.8   c0-8.8,5.5-15.4,13.5-15.4c8,0,11.5,4.7,11.5,12.9c0,1.4-0.3,2.9-0.3,3H795.6z M809,840.8c0-4.1-1.6-7.5-6-7.5   c-4.4,0-6.9,3.4-7.2,7.5H809z",
    id: "path102",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.8,844.9c0,6,3.2,9.9,8,9.9c5.5,0,9.2-3,9.2-3l1.9,2.9c0,0-5.1,4.6-11.7,4.6c-8.8,0-13.2-5.8-13.2-14.8   c0-8.8,5.5-15.4,13.5-15.4c8,0,11.5,4.7,11.5,12.9c0,1.4-0.3,2.9-0.3,3H825.8z M839.2,840.8c0-4.1-1.6-7.5-6-7.5   c-4.4,0-6.9,3.4-7.2,7.5H839.2z",
    id: "path104",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.3,833.5c1.4-1.5,4.6-4.6,8.3-4.6c2.8,0,4.9,0.8,4.9,0.8l-0.3,8h-3.6l-0.8-4.1c-4.1,0-6.8,2.7-8,4.3v16.3l5.5,1.4v3   h-15.7v-3l4.7-1.4v-20.3l-4.7-1.1v-3l9.1-0.3L859.3,833.5z",
    id: "path106",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.1,854.6c0,0,1.6,0.5,4.6,0.5c3.3,0,6.2-0.9,6.2-4.3c0-5.9-15.3-3.2-15.3-13.2c0-5.7,4.4-8.6,10.1-8.6   c4.3,0,9.4,1.7,9.4,1.7l-0.2,7.4h-3.6l-0.9-4.3c0,0-1.7-0.7-4.5-0.7c-2.8,0-4.9,0.9-4.9,3.7c0,5.9,15.3,3.6,15.3,13   c0,6.3-5.5,9.4-12.1,9.4c-5.1,0-8.7-1.2-8.7-1.2v-8.1h3.8L880.1,854.6z",
    id: "path108",
    style: {
      fill: "#ffffff"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g112"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g114"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g116"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g118"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g120"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g122"
  })), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccccccccccccsccccccccccccccccccccccccccccccccccccccccccsssccccccccccc",
    style: {
      opacity: 1,
      fill: "#ffffff",
      stroke: "none",
      strokeWidth: 0.70300001,
      strokeOpacity: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 344.77094,483.60971 v -65.01937 h 49.20385 49.20385 v -49.55531 -49.5553 h 49.5553 49.55531 V 270.27588 244 221.07203 h 64.66791 64.66791 l 0.0842,49.02812 c 0.11028,64.22448 0.11151,167.3583 0.003,229.14935 l -0.087,49.37958 h -15.46406 -15.46407 v -49.55531 -49.5553 h -33.73978 -33.73978 v 49.5553 49.55531 h -15.45932 -15.45932 l -0.18048,-49.37958 -0.18047,-49.37957 -33.56405,-0.18255 -33.56406,-0.18254 v 49.56212 49.56212 h -15.81552 -15.81552 v -49.55531 -49.5553 h -33.38833 -33.38832 v 49.5553 49.55531 h -15.81553 -15.81552 z m 196.81539,-98.75915 v -33.73978 h -33.38832 -33.38833 v 33.73978 33.73978 h 33.38833 33.38832 z m 99.11061,0 v -33.73978 h -33.73978 -33.73978 v 33.27117 c 0,18.29915 0.21087,33.48205 0.46861,33.73978 0.25773,0.25773 15.44063,0.46861 33.73978,0.46861 h 33.27117 z m 0,-98.75916 v -33.38832 h -33.73978 -33.73978 v 33.38832 33.38833 h 33.73978 33.73978 z",
    id: "path1609"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildsoftLogoSquareDark);
export default __webpack_public_path__ + "static/media/buildsoft-logo-square-dark.32161f60b904bb1b75d3c5e10ac1f9c7.svg";
export { ForwardRef as ReactComponent };